import { render } from "./ProjectStatus.vue?vue&type=template&id=1663aa8d&scoped=true"
import script from "./ProjectStatus.vue?vue&type=script&lang=js"
export * from "./ProjectStatus.vue?vue&type=script&lang=js"

import "./ProjectStatus.vue?vue&type=style&index=0&id=1663aa8d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1663aa8d"]])

export default __exports__